<template>
	<div>
		<b-button
			v-ripple.400="'rgba(113, 102, 240, 0.15)'"
			size="md"
			variant="outline-primary"
			class="btn-icon"
			@click="getFiles"
		>
			<feather-icon
				size="1x"
				icon="UploadIcon"
			/>
			<small class="text-nowrap">CARGAR ARCHIVOS</small>
		</b-button>

		<b-modal
			ref="modal"
			title="ARCHIVOS DE EVIDENCIA"
			size="xl"
			modal-class="modal-primary"
			no-close-on-backdrop
			no-close-on-esc
			centered
		>
			<template>
				<hr />

				<div class="my-1">
					<vue-dropzone
						ref="dropzone"
						id="dropzone"
						:options="dropzoneOptions"
						:headers="dropzoneHeaders"
						:useCustomSlot="true"
						@vdropzone-sending-multiple="vsending"
						@vdropzone-success-multiple="vsuccess"
						@vdropzone-error="verror"
					>
						<div class="dropzone-custom-content">
							<h4 class="dropzone-custom-title">
								<strong>¡Arrastre o haga click aquí para cargar contenido!</strong>
							</h4>
							<!-- <div
								class="subtitle"
							>solo archivos {{ newExtensions ? 'PDF, EXCEL, PPT, IMAGEN o WORD' : 'PDF o EXCEL'}}</div>-->
						</div>
					</vue-dropzone>
				</div>

				<hr />
			</template>

			<table class="table table-bordered text-center w-100 mt-2 mb-1">
				<thead>
					<tr>
						<th>#</th>
						<th colspan="2">Archivo</th>
						<th>Fecha de carga</th>
						<th>Opciones</th>
					</tr>
				</thead>

				<tbody>
					<tr v-if="!files.length">
						<td colspan="5">NO HAY NINGÚN ARCHIVO CARGADO.</td>
					</tr>
					<tr
						v-for="(item, index) in files"
						:key="index"
					>
						<td>
							<span class="text-nowrap">{{ index + 1 }}</span>
						</td>
						<td colspan="2">{{ item.original_name }}</td>
						<td>
							<span class="text-nowrap">{{ moment(item.createdAt).format('DD/MM/YYYY HH:mm A') }}</span>
						</td>
						<td>
							<div class="justify-content-center align-items-center">
								<b-button
									:href="item.url"
									target="_blank"
									v-ripple.400="'rgba(40, 199, 111, 0.15)'"
									variant="flat-primary"
									class="btn-icon rounded-circle"
									title="Descargar"
								>
									<feather-icon icon="DownloadIcon" />
								</b-button>

								<b-button
									v-ripple.400="'rgba(40, 199, 111, 0.15)'"
									variant="flat-danger"
									class="btn-icon rounded-circle"
									title="Eliminar"
									@click="deleteFile(item.id)"
								>
									<feather-icon icon="TrashIcon" />
								</b-button>
							</div>
						</td>
					</tr>
				</tbody>
			</table>

			<template #modal-footer="{ cancel }">
				<b-button
					variant="outline-secondary"
					@click="cancel(); reset()"
				>CERRAR</b-button>
			</template>
		</b-modal>
	</div>
</template>

<script>
import { ref, onBeforeMount, onUnmounted } from "@vue/composition-api"
import uploadFileStoreModule from "./uploadFileStoreModule"
import useNotifications from "@notifications"
import "vue2-dropzone/dist/vue2Dropzone.min.css"
import { getUserRoles } from "@/auth/utils"
import Ripple from "vue-ripple-directive"
import vue2Dropzone from "vue2-dropzone"
import store from "@/store"
import moment from "moment"
import axios from "@axios"
import Vue from "vue"
import "animate.css"

export default {
	components: {
		vueDropzone: vue2Dropzone
	},
	directives: {
		Ripple
	},
	data() {
		return {
			moment
		}
	},
	setup() {
		const UPLOAD_FILE_APP_STORE_MODULE_NAME = "app-upload-file"

		// REGISTER MODULE
		if (!store.hasModule(UPLOAD_FILE_APP_STORE_MODULE_NAME))
			store.registerModule(
				UPLOAD_FILE_APP_STORE_MODULE_NAME,
				uploadFileStoreModule
			)

		// UNREGISTER ON LEAVE
		onUnmounted(() => {
			if (store.hasModule(UPLOAD_FILE_APP_STORE_MODULE_NAME))
				store.unregisterModule(UPLOAD_FILE_APP_STORE_MODULE_NAME)
		})

		const { swalNotification } = useNotifications()

		// REFS
		const modal = ref(null)
		const files = ref([])
		const payload = ref({})

		const dropzone = ref(null)
		const dropzoneOptions = ref({})
		const dropzoneHeaders = ref({})
		const acceptedFiles = ref(null)

		const setDropzoneConfig = () => {
			dropzoneHeaders.value = {
				"Content-Type": "multipart/form-data"
			}
			dropzoneOptions.value = {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("accessToken")}`
				},
				url: `${process.env.VUE_APP_HOST}/api/dashboard/files`,
				method: "post",
				paramName: "files",
				autoDiscover: false,
				maxFiles: 10,
				timeout: 180000,
				maxThumbnailFilesize: 10,
				parallelUploads: 10,
				// acceptedFiles: acceptedFiles.value,
				addRemoveLinks: false,
				autoProcessQueue: true,
				thumbnailWidth: 140,
				thumbnailHeight: 140,
				dictRemoveFile: "Eliminar",
				uploadMultiple: true
			}
		}

		const fetchFiles = () => {
			const params = { is_evidence: 1 }

			store
				.dispatch("app-upload-file/fetchFiles", { payload: params })
				.then((response) => {
					files.value = response.data.files
					modal.value.show()
				})
				.catch((error) => {
					swalNotification(error.response.data.message, false)
				})
		}

		const reset = () => {
			payload.value = {}
		}

		const getFiles = () => {
			setDropzoneConfig()
			fetchFiles()
		}

		const deleteFile = (id) => {
			Vue.swal({
				title: "¿Está seguro(a) de eliminar el archivo?",
				html: "<small>¡Si no lo está, puede cancelar la acción!</small>",
				icon: "warning",
				showCancelButton: true,
				confirmButtonText: "Sí, eliminar!",
				cancelButtonText: "Cancelar",
				customClass: {
					confirmButton: "btn btn-primary",
					cancelButton: "btn btn-outline-danger ml-1"
				},
				showClass: {
					popup: "animate__animated animate__tada"
				},
				buttonsStyling: false
			}).then((result) => {
				if (result.value) {
					store
						.dispatch("app-upload-file/deleteFile", { id })
						.then((response) => {
							getFiles()
							swalNotification(response.data.message)
						})
						.catch(() => {
							swalNotification("Error al eliminar el archivo", false)
						})
				}
			})
		}

		const vsending = (files, xhr, formData) => {
			const fileData = {
				...payload.value,
				files_count: files.length
			}
			formData.append("fileData", JSON.stringify(fileData))
		}

		const vsuccess = (files, response) => {
			getFiles()

			if (dropzone.value) {
				dropzone.value.removeAllFiles()
			}

			swalNotification(response.message, true, 3500)
		}

		const verror = (files, response, xhr) => {
			getFiles()

			if (dropzone.value) {
				dropzone.value.removeAllFiles()
			}

			swalNotification(response.message, false)
		}

		return {
			// DROPZONE
			dropzoneOptions,
			dropzoneHeaders,
			dropzone,
			vsending,
			vsuccess,
			verror,

			// REFS
			modal,
			files,

			// ACTIONS
			getFiles,
			deleteFile,
			reset
		}
	}
}
</script>

<style lang="scss" scoped>
.description-modal {
	font-size: 1.2rem;
	font-weight: bold;
}

.content-modal {
	font-size: 0.85rem;
}
</style>

<style>
.vue-dropzone {
	border-radius: 15px !important;
	border-style: dotted !important;
	border: 2px solid #3b4253 !important;
}

.dropzone {
	background: transparent !important;
}

.dropzone .dz-preview .dz-image {
	border-radius: 10px !important;
}

.dropzone .dz-preview.dz-image-preview {
	background: transparent !important;
}

.vue-dropzone > .dz-preview .dz-details {
	background: transparent !important;
}

.vue-dropzone > .dz-preview .dz-remove {
	margin-left: 22px !important;
}

.ql-container {
	min-height: 200px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-sweetalert.scss";
</style>